import React from 'react'
import * as requestFormType from './newProjectType'
import useRequestForm from './useNewProject'

// --- MaterialUI --- //
import { Grid, makeStyles } from '@material-ui/core'

// --- FinalForm --- //
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

// --- Control --- //
import Dialog from '../../../../../../control/dialog/dialog'

// --- Share UI --- //
import EthicsForm from '../../../../shareUI/ethicsForm/ethicsForm'
import ResearcherForm from '../../../../shareUI/researcherForm/researchForm'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'
import RemarkFromAdmin from '../../../../shareUI/remarkFromAdmin/remarkFromAdmin'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useSnackbarAction from '../../../../../../stores/snackbar/snackbarAction'

import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import useTranslate from '../../../../../../i18n/useTranslate'
import PageAction from '../../pageAction'
import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useCheckPermission from '../../../../../../utilities/checkPermission'

type ErrorsType = {
    langTH?: string
    langEN?: string
}

//View
const RequestFormView = (props: requestFormType.RequestFormView) => {
    const {
        isDraftData,
        onClickDeleteProject,
        onClickSubmit,
        onClickCancel,
        onRefDialogTwo,
        configDialog,
        handleChangeFaculty,
        selectedIrb,
        isApproveWithComment,
        isEditAfterReview = false,
        initialDataValue,
        btnClose,
        isViewMode = false,
        initialUploadFile = [],
        projectData,
        handleDirtyChange,
        onChangeResearcherType,
        valuesForm,
        formValueRef,
        researcherTypeRef,
    } = props
    //* STORE *//
    const manageProjectStore = useManageProjectStore()
    const snackbarAction = useSnackbarAction()
    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const { documentTopic } = manageProjectStore
    const { profile } = useAuthenStore()

    const translate = useTranslate()
    const uploadFileinit = documentTopic?.map(() => {
        return {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
            },
        }
    })

    const isNotCompleteDocument = projectData?.submittedStatusInfo?.value === constSubmittedStatus.incorrectDocument
    const isDisableDoc = isViewMode && (!isNotCompleteDocument || !isApproveWithComment)

    let isDisableIRB = false
    if (isApproveWithComment || isEditAfterReview || !profile.isCunet || valuesForm.current?.faculty?.value === '7') {
        isDisableIRB = true //Flow approveWithComment ให้ Disable IRB หรือ flow แก้ไขหลังพิจารณา
    }

    let isUploadEditMode = false
    if (isApproveWithComment || isNotCompleteDocument || isEditAfterReview) {
        isUploadEditMode = true
    }

    const getRECDocumentLink = (irb: string) => {
        if (irb === '1') {
            return process.env.REACT_APP_REC1_LINK ?? ''
        } else if (irb === '2') {
            return process.env.REACT_APP_REC2_LINK ?? ''
        } else {
            return ''
        }
    }

    return (
        <Form
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{
                ...initialDataValue,
                uploadFile: initialUploadFile && initialUploadFile.length > 0 ? initialUploadFile : uploadFileinit,
                documentAdditionalInfo: projectData?.documentAdditionalInfo ?? [],
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!values.langTH && !values.langEN) {
                    errors.langTH = translate.get('MESSAGE.M016')

                    errors.langEN = translate.get('MESSAGE.M016')
                }

                return errors
            }}
        >
            {({ handleSubmit, form, dirty, invalid, errors, values }) => {
                valuesForm.current = values
                if (formValueRef) formValueRef.current = values
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            {projectData?.verifyDocument === false && (
                                <Grid item xs={12}>
                                    <RemarkFromAdmin
                                        isShow={projectData?.verifyDocument === false}
                                        projectData={projectData ?? undefined}
                                    />
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <EthicsForm
                                    callbackChangeFaculty={handleChangeFaculty}
                                    disabled={isViewMode || isApproveWithComment}
                                    isNotCompleteDocument={isNotCompleteDocument}
                                    isDisableRIB={isDisableIRB || isViewMode}
                                    isDisablePhase={isViewMode || isApproveWithComment}
                                    isDisableNumPhase={isViewMode || isApproveWithComment}
                                    callbackChangeResearcherType={onChangeResearcherType}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherForm disabled={isViewMode || isApproveWithComment} />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                style={{ display: documentTopic?.length ? 'inherit' : 'none' }}
                            >
                                <UploadDoc
                                    documentTitleList={documentTopic ?? []}
                                    initialData={initialUploadFile}
                                    selectedIrb={selectedIrb}
                                    isViewMode={isDisableDoc && !canUpdateDocument}
                                    latestDocument={projectData?.latestDocument}
                                    isUseUploadfileEdit={isUploadEditMode}
                                    linkProps={[
                                        {
                                            title: translate.get('LABEL.ENTER_REC_1_WEBSITE'),
                                            url: getRECDocumentLink('1'),
                                        },
                                        {
                                            title: translate.get('LABEL.ENTER_REC_2_WEBSITE'),
                                            url: getRECDocumentLink('2'),
                                        },{
                                            title: translate.get('LABEL.ENTER_REC_3_WEBSITE'),
                                            url: 'https://www.dent.chula.ac.th/offices/office-of-research-and-innovation/services/',
                                        }
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadAdditionalDoc 
                                    isViewMode={isDisableDoc && !canUpdateDocument}
                                    isEditable={isViewMode}
                                />
                            </Grid>

                            {!btnClose || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickDeleteProject={
                                            isDraftData
                                                ? () => {
                                                      onClickDeleteProject()
                                                  }
                                                : undefined
                                        }
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>

                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const RequestFormCtrl = (props: requestFormType.RequestFormType) => {
    const requestFormModel = useRequestForm(props)
    return <RequestFormView {...requestFormModel} {...props} />
}
export default RequestFormCtrl
